"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransferSchemas = exports.getApproveSchemas = exports.getIsApproveSchemas = exports.getBalanceSchemas = exports.common = exports.schemas = exports.getParams = exports.encodeParamsCall = exports.encodeWeb3Call = exports.encodeCall = exports.encodeSell = exports.encodeBuy = void 0;
var tron_1 = require("./tron");
var shasta_1 = require("./shasta");
var registry_1 = require("./common/Element/registry");
var exchange_1 = require("./common/Element/exchange");
var ERC20_1 = require("./common/ERC20");
var ERC721_1 = require("./common/ERC721");
var ERC1155_1 = require("./common/ERC1155");
var types_1 = require("../utils/types");
var schemasFunctions_1 = require("./schemasFunctions");
Object.defineProperty(exports, "encodeBuy", { enumerable: true, get: function () { return schemasFunctions_1.encodeBuy; } });
Object.defineProperty(exports, "encodeSell", { enumerable: true, get: function () { return schemasFunctions_1.encodeSell; } });
Object.defineProperty(exports, "encodeCall", { enumerable: true, get: function () { return schemasFunctions_1.encodeCall; } });
Object.defineProperty(exports, "encodeWeb3Call", { enumerable: true, get: function () { return schemasFunctions_1.encodeWeb3Call; } });
Object.defineProperty(exports, "encodeParamsCall", { enumerable: true, get: function () { return schemasFunctions_1.encodeParamsCall; } });
Object.defineProperty(exports, "getParams", { enumerable: true, get: function () { return schemasFunctions_1.getParams; } });
exports.schemas = {
    tron: tron_1.tronSchemas,
    shasta: shasta_1.shastaSchemas,
};
exports.common = {
    APENFTRegistrySchemas: registry_1.APENFTRegistrySchemas,
    APENFTExchangeSchemas: exchange_1.APENFTExchangeSchemas,
    ERC20Schema: ERC20_1.ERC20Schema,
    ERC721Schema: ERC721_1.ERC721Schema,
    ERC1155Schema: ERC1155_1.ERC1155Schema
};
function getBalanceSchemas(metadata) {
    var address = metadata.asset.address;
    var tokenId = metadata.asset.id;
    var schema = metadata.schema;
    var accountApprove = ERC1155_1.ERC1155Schema.functions.countOf({ address: address, id: tokenId });
    if (schema === types_1.APENFTSchemaName.ERC721) {
        accountApprove = ERC721_1.ERC721Schema.functions.ownerOf({ address: address, id: tokenId });
    }
    return accountApprove;
}
exports.getBalanceSchemas = getBalanceSchemas;
function getIsApproveSchemas(metadata) {
    var address = metadata.asset.address;
    var schema = metadata.schema;
    var accountApprove = ERC1155_1.ERC1155Schema.functions.isApprove({ address: address });
    if (schema === types_1.APENFTSchemaName.ERC721) {
        accountApprove = ERC721_1.ERC721Schema.functions.isApprove({ address: address });
    }
    return accountApprove;
}
exports.getIsApproveSchemas = getIsApproveSchemas;
function getApproveSchemas(metadata) {
    var address = metadata.asset.address;
    var schema = metadata.schema;
    var accountApprove = ERC1155_1.ERC1155Schema.functions.approve({ address: address });
    if (schema === types_1.APENFTSchemaName.ERC721) {
        accountApprove = ERC721_1.ERC721Schema.functions.approve({ address: address });
    }
    return accountApprove;
}
exports.getApproveSchemas = getApproveSchemas;
function getTransferSchemas(metadata) {
    var address = metadata.asset.address;
    var data = '0x';
    var quantity;
    if ('quantity' in metadata.asset) {
        quantity = metadata.asset.quantity;
    }
    if ('data' in metadata.asset) {
        data = metadata.asset.data || data;
    }
    var tokenId = metadata.asset.id;
    var schema = metadata.schema;
    var accountApprove = ERC1155_1.ERC1155Schema.functions.transfer({ address: address, id: tokenId, quantity: quantity, data: data });
    if (schema === types_1.APENFTSchemaName.ERC721) {
        accountApprove = ERC721_1.ERC721Schema.functions.transfer({ address: address, id: tokenId });
    }
    if (schema === types_1.APENFTSchemaName.ERC1155) {
        if (!data) { }
    }
    return accountApprove;
}
exports.getTransferSchemas = getTransferSchemas;
